<template>
<div>
    <div v-if="finish === false" >
        <div class="text-center" style="text-align: center;margin-top:100px">
                <v-progress-circular v-if="finish === false"
                        :size="70"
                        :width="7"
                        color="primary"
                        indeterminate>
                </v-progress-circular>  
        </div>
    </div>
    <div v-if="finish">
        <v-toolbar
                dense
                color="primary"
                dark
                extended
                extension-height="220"
                flat
        >
            <div style="width:-webkit-fill-available;text-align:right;">
                <v-menu> 
                    <v-btn icon slot="activator">
                        <v-avatar class="white" size="32">
                            <v-icon color="primary">person</v-icon>
                        </v-avatar>
                    </v-btn>
                    <v-list class="pa-0" light>
                    

                        <v-list-tile  @click="dialog_cad = true">
                            <v-list-tile-action>
                                <v-icon>vpn_key</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>Alterar Senha</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>


                        
                         <v-list-tile  @click="alterar_digital()">
                            <v-list-tile-action>
                                <v-icon>email</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>Carnê Digital</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>

                        <v-list-tile @click="logout" >
                            <v-list-tile-action>
                                <v-icon>lock_open</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>Sair</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-menu>

            </div>
            <v-toolbar-title slot="extension" style="margin-left: 8px !important">
                <span>Seja Bem Vindo!</span>
                <h3>{{this.cliente.NomeCompleto}}</h3> 
                <h6>CEP: {{this.cliente.EnderecoCep}}</h6> 
                <h6>{{this.cliente.EnderecoLogradouro}}, Nº{{this.cliente.EnderecoLogradouroNumero}}</h6> 
                <h6>Contato: {{this.cliente.PrefixoTelefone}}{{this.cliente.Telefone}} - {{this.cliente.PrefixoCelular}}{{this.cliente.Celular}} <br/> Email: {{this.cliente.Email}}</h6> 

                <v-layout row  style="width: fit-content">

                    <v-flex wrap>
                        <v-btn outline fab color="white"  @click="dlg_lista = true" class="outine-2" small>
                              <i class="fa fa-tasks fa-2x" ></i>
                        </v-btn>
                    </v-flex>

                    <v-flex wrap>
                        <v-btn outline  fab color="white"  @click="dlg_end = true" class="outine-2" small>
                              <i class="fa fa-users fa-2x"></i>
                        </v-btn>
                    </v-flex>

                    <v-flex wrap>
                        <v-btn outline  fab color="white"  @click="dlg_end = true" class="outine-2" small>
                              <i class="fa fa-id-card fa-2x"></i>
                        </v-btn>
                    </v-flex>
                    
                   <v-flex wrap>
                        <v-btn outline  fab color="white" to="/contato" class="outine-2" small>
                              <i class="fa fa-at fa-2x"></i>
                        </v-btn>
                    </v-flex>

                    <v-flex wrap>
                        <v-btn outline  fab color="white" to="/sinistro" class="outine-2" small>
                              <i class="fa fa-cross fa-2x"></i>
                        </v-btn>
                    </v-flex>

                    
                </v-layout>
            </v-toolbar-title>
        </v-toolbar>

        <v-container >
          
            <v-layout row  >
                <v-flex>
                    <v-card flat  color="transparent">
                        <v-container fluid grid-list-lg >
                            <v-layout row wrap>
                                <v-flex md12 lg3 v-for="item in links" :key="item.id">
                                    <v-hover>
                                        <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
                                        
                                            <v-card flat style="color:white;text-align: center;" class="text-xs-center"
                                                    height="110px"
                                                    :class="item.color">  
                                                <br/>

                                                <i v-if="item.id === '1'" class="fa fa-tasks fa-3x"></i>
                                                <i v-if="item.id === '2'" class="fa fa-users fa-3x"></i>
                                                <i v-if="item.id === '3'" class="fa fa-id-card fa-3x"></i>
                                                <i v-if="item.id === '4'" class="fa fa-at fa-3x"></i>
                                                <i v-if="item.id === '5'" class="fa fa-cross fa-3x"></i>
                                                <i v-if="item.id === '6'" class="fa fa-comments fa-3x"></i>

                                            </v-card>
                                            
                                            <v-card-title primary-title>
                                                <div>
                                                    <h3 class="headline mb-0">{{item.title}}</h3>
                                                    <div style="height:80px">
                                                        {{item.description}}
                                                    </div>
                                                </div>
                                            </v-card-title>

                                            <v-card-actions>
                                               
                                                <v-spacer></v-spacer>
                                                <v-btn v-if="item.id === '1'" @click="dlg_lista = true" flat color="primary">Entrar</v-btn>
                                                <v-btn v-if="item.id === '2'" @click="dlg_lista_dep = true" flat color="primary">Entrar</v-btn>
                                                <v-btn v-if="item.id === '3'" @click="dlg_end = true" flat color="primary">Entrar</v-btn>
                                                <v-btn v-if="item.id === '4'" to="/contato" flat color="primary">Entrar</v-btn>
                                                <v-btn v-if="item.id === '5'" to="/sinistro" flat color="primary">Entrar</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-hover>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

      <v-dialog  v-model="dlg_carne_digital" max-width="340px">
            <v-card>
                <v-toolbar color="primary" dark> <span class="headline">Carnê Digital</span></v-toolbar>
                <v-card-text>
                    <br/>
                       
                        Receber sua conta por e-mail é uma facilidade que o Previda oferece! Basta autorizar o envio. Você receberá os seus próximos carnês por e-mail, sem necessidade da entrega do carnê ou acúmulo de papel.</v-card-text>
                    <v-spacer></v-spacer>

                        <v-card-actions>    
                            <v-btn block class="ma-2 white--text" 
                                color="green darken-1"  :loading="btn_resposta_load" :disabled="btn_resposta_load" 
                                @click="responder('SIM')" >
                                QUERO RECEBER MINHA FATURA VIRTUAL
                            </v-btn>
                            
                        </v-card-actions>

                        <v-card-actions>    
                            <v-btn block class="ma-2 white--text" 
                                color="green darken-1"  :loading="btn_resposta_load" :disabled="btn_resposta_load"    
                                @click="responder('NÃO')" >
                                Manter Carnê Impresso
                            </v-btn>
                        </v-card-actions>

                        <v-card-actions>    
                            <v-btn block class="ma-2 white--text" 
                                color="light-green lighten-1"     
                                @click="nao_decidi()" >
                                Decidir depois
                            </v-btn>
                        </v-card-actions>

            </v-card>
        </v-dialog>

      <v-dialog  v-model="dlg_retorno_digital" max-width="300px">
            <v-card>
                <v-toolbar color="primary" dark> <span class="headline">Mensagem</span></v-toolbar>
                <v-card-text>
                    Solicitação enviada com sucesso! Qualquer dúvida entrar em contato conosco.
                    <br/>
                    Telefone: 0800 009 1700
                    <br/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text  @click="dlg_retorno_digital = false"> OK </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



        <v-dialog  v-model="dlg_lista" max-width="500px">
            <v-card>
                <v-toolbar color="primary" dark> <span class="headline">Confirmar Contrato</span></v-toolbar>
                <v-card-text>
                    <br/>
                    <v-select  v-model="escolhido"  :items="this.lista_contratos_" label="Selecione seu contrato" item-text="Referencia" box></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text flat @click="dlg_lista = false" > Sair </v-btn>
                    <v-btn color="primary" text  @click="acessar_mensalidade"> Confirmar </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

         <v-dialog  v-model="dlg_lista_dep" max-width="500px">
            <v-card>
                <v-toolbar color="primary" dark> <span class="headline">Confirmar Contrato</span></v-toolbar>
                <v-card-text>
                    <br/>
                    <v-select  v-model="escolhido"  :items="this.lista_contratos_" label="Selecione seu contrato" item-text="Referencia" box></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text flat @click="dlg_lista_dep = false" > Sair </v-btn>
                    <v-btn color="primary" text  @click="acessar_dep"> Confirmar </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



        <v-dialog  v-model="dlg_end" max-width="500px">
            <v-card>
                <v-toolbar color="primary" dark> <span class="headline">Endereço</span></v-toolbar>
                 <v-card-text>
                 <v-layout wrap>
                    <v-flex xs12>
                        <v-input 
> 
                            ENDEREÇO ATUAL <br/>
                            CEP: {{this.cliente.EnderecoCep}} <br/>
                            {{this.cliente.EnderecoLogradouro}}, Nº{{this.cliente.EnderecoLogradouroNumero}}<br/>
                            Complemento: {{this.cliente.EnderecoComplemento}} - Bairro: {{this.cliente.EnderecoBairro.Nome}}<br/>
                            Cidade: {{this.cliente.EnderecoCidade.Nome}} - UF: {{this.cliente.EnderecoUF.Nome}}
                        </v-input>
                    </v-flex>
                 </v-layout>
                 </v-card-text>

                
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text flat @click="dlg_end = false" > Sair </v-btn>
                    <v-btn color="primary" text  @click="acessar_endereco"> Alterar Endereço </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



    </div>

    <v-dialog
      v-model="dialog_cad"
      persistent
      max-width="500px"
    >
       <v-form
        ref="form"
        v-model="valid"
        lazy-validation>

      <v-card>
        <v-card-title>
          <span class="headline">Alterar Senha</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
                <v-flex xs12>
                  <v-text-field color="success"
                    label="EMAIL" Required :rules="[v => !!v || 'Campo Obrigatório']"
                    flat v-model="cadastro.email"
                    prepend-inner-icon="alternate_email"
                  ></v-text-field>
                </v-flex>

              <v-flex xs12>
                  <v-text-field color="success" Required :rules="[v => !!v || 'Campo Obrigatório']"
                    label="SENHA" type="password" v-model="cadastro.senha"
                    prepend-inner-icon="vpn_key"
                    flat 
                  ></v-text-field>
                </v-flex>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            flat
            :disabled="btn_cad_load"
            @click="dialog_cad = false"
          >
            Sair
          </v-btn>
          <v-btn
            color="success"
            :loading="btn_cad_load"
            text
            @click="handleAlt"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
       </v-form>
    </v-dialog>

     <v-dialog v-model="finish_alterar_senha" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Mensagem</v-card-title>
                <v-card-text>{{msg_finish_alterar}}</v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="finish_alterar_senha = false" >OK</v-btn>
                </v-card-actions>
            </v-card>
    </v-dialog>

    <v-dialog
      v-model="dlg_roleta" 
      persistent 
      width="620px" >
     
      <v-card style="background-color:rgb(0 0 0 / 0%)"> 
            <div align="center">
                <table cellpadding="0" cellspacing="0" border="0">
                    <tr>
                        <br/>
                        <br/>
                        <td width="580" height="580" class="the_wheel" align="center" valign="center">
                            <br/>
                            <br/>
                            <br/>
                            <canvas id="canvas" width="540" height="540">
                            
                            </canvas>  
                             <v-btn rounded color="green" dark @click="startSpin()"> GIRAR ROLETA </v-btn>        
                            <br />  
                        </td>
                    </tr>
                </table>
            </div> 
      </v-card>
    </v-dialog>

    

    </div>
</template>

<script>
import { http } from '../../services/config'
import { httpOpen } from '../../services/configOpen'
import axios from 'axios'
import authHeader from '../../services/auth-header';
import { mapGetters, mapActions } from 'vuex'
import AuthService from '../../services/auth.service'
import Winwheel from '../../css/Winwheel.js';
import Promotor from '../../services/promotor'

    export default {
       
        computed:{
            ...mapGetters([
                    'lista_contratos' , 'cliente_select', 
                ]),


        },

        data() {
            return {
                cliente: {},
                theWheel: null,
                wheelPower: 0,
                wheelSpinning: false,
                dlg_carne_digital: false,
                dlg_retorno_digital: false,
                finish_alterar_senha:false,
                msg_finish_alterar: '',
                dialog_cad: false,
                dlg_roleta: false,
                btn_cad_load: false,
                finish: false,
                btn_resposta_load: false,
                cadastro: {
                    email: '',
                    senha: '',
                },
                carne_aceito: {
                    contrato: '',
                    resposta: '',
                    codigo: '',
                    ip: '',
                    plataforma: 'WEB'
                },

                lista_contratos_: [],
                conti: [],
                dlg_lista: false,
                dlg_lista_dep: false,
                dlg_end: false,
                cliente: {},
                escolhido:{},
                links: [
                    {
                        id: '1',
                        title: 'Mensalidade',
                        description: 'Pague sua mensalidade no cartão de crédito ou pegue o código de barras do seu boleto',
                        color: 'orange',
                        url: '/mensalidade',
                    },
                    {
                        id: '2',
                        title: 'Dependente',
                        description: 'Mantenha o cadastro dos dependentes atualizado',
                        color: 'red',
                        url: '/Dependente',
                    },
                    
                    {
                        id: '3',
                        title: 'Endereço',
                        description: 'Mantenha atualizado suas informações (Endereço de Cadastro e Cobrança)',
                        color: 'teal',
                        url: '/mensalidade',
                    },
                    {
                        id: '4',
                        title: 'Contato',
                        description: 'Mantenha atualizado suas informações de contatos (Telefones e E-mail)',
                        color: 'blue',
                        url: '/mensalidade',
                    },
                    {
                        id: '5',
                        title: 'Óbito',
                        description: 'Informações para abertura de Sinistro.',
                        color: 'purple',
                        url: '/mensalidade',
                    },
                   
                ]
            }
        },
      
        mounted() {
           
            if(this.$store.getters.lista_contratos === undefined | this.isEmptyObject(this.$store.getters.lista_contratos)){
                http.get('ContratoDIO/Listar/', {
                    headers: authHeader()
                }).then(response =>{
                        var lista_contratos_aux = response.data.ResponseData;
                        this.lista_contratos_ = [];
                            for (var key in lista_contratos_aux) {
                                this.validCNPJ(lista_contratos_aux[key], lista_contratos_aux[key].Tipo.Id);
                            } 
                    })
                    .catch(function (error) {
                        this.logout();
                    });
            }else{

                         this.lista_contratos_ = this.$store.getters.lista_contratos;

                        for (var key in  this.lista_contratos_) {
                            this.id_cliente = this.lista_contratos_[key].Cliente.Id
                            sessionStorage.setItem('contrato_token', this.lista_contratos_[key].Referencia);

                            } 
                        this.request_obter_cliente(this.id_cliente)

            }
        },

        methods:{
                logout(){
                      sessionStorage.removeItem('user')
                      this.$router.push('/')
                },

                acessar_mensalidade(){
                     //localStorage.setItem('ls_contratos', self.contratos)
                     for (var key in  this.lista_contratos_) {
                      

                         if(this.lista_contratos_[key].Referencia === this.escolhido){
                            sessionStorage.setItem('id_c_s', JSON.stringify(this.lista_contratos_[key]))
                            this.dlg_lista = false;
                            this.$router.push('/mensalidade')

                         }
                    } 
                    this.dlg_lista = false;
                },


                resetWheel()
                {
                    this.theWheel.stopAnimation(false);  // Stop the animation, false as param so does not call callback function.
                    this.theWheel.rotationAngle = 0;     // Re-set the wheel angle to 0 degrees.
                    this.theWheel.draw();                // Call draw to render changes to the wheel.

                    //document.getElementById('pw1').className = "";  // Remove all colours from the power level indicators.
                    //document.getElementById('pw2').className = "";
                    //document.getElementById('pw3').className = "";

                    this.wheelSpinning = false;          // Reset to false to power buttons and spin can be clicked again.
                },
                
                alertPrize(){
                    //alert("You have won ");
                },

                startSpin()
                        {
                            // Ensure that spinning can't be clicked again while already running.
                            if (this.wheelSpinning == false) {
                                // Based on the power level selected adjust the number of spins for the wheel, the more times is has
                                // to rotate with the duration of the animation the quicker the wheel spins.
                                this.theWheel.animation.spins = 8; 
                                this.theWheel.startAnimation();
                                this.wheelSpinning = true;        
                                
                            }
                        },
               
                acessar_dep(){
                     for (var key in  this.lista_contratos_) {
                         if(this.lista_contratos_[key].Referencia === this.escolhido){
                            sessionStorage.setItem('id_c_s', JSON.stringify(this.lista_contratos_[key]))
                            this.dlg_lista_dep = false;
                            this.$router.push('/dependente')
                         }
                    } 
                    this.dlg_lista = false;
                },

                pontosCarne(){
                    const obj = {};
                    obj.key = sessionStorage.getItem('token');
                    obj.contrato = sessionStorage.getItem('contrato_token')
                    obj.token = "";
                    obj.evento = "CARNÊ DIGITAL"
                    obj.valorantigo = "";
                    obj.valornovo = "";
                    
                    Promotor.incluirPontoCarne(obj).then(response => {

                                                    if(response.status = 200){
                                                        this.eventos = response.data;
                                                    }
                                                }).catch(e => {
                                                }).finally(() => {
                                                });
                            
                },


                acessar_endereco(){
                    this.dlg_end = false;
                    this.$router.push('/endereco')
                },
            
             validCNPJ(ContratoAux, id_plano) { 
                                httpOpen.get('empresadoplano/'+ id_plano, {
                                    headers: authHeader()
                                })
                                .then(response => {
                                  
                                  if(response.data == 'PREVIDA'){
                                      
                                        this.id_cliente = ContratoAux.Cliente.Id
                                        if(ContratoAux.RegistroAtivo){
                                            this.carne_aceito.contrato = ContratoAux.Referencia;
                                            this.carne_aceito.codigo = this.id_cliente;
                                            this.lista_contratos_.push(ContratoAux);
                                            sessionStorage.setItem('contrato_token', ContratoAux.Referencia);
                                        }

                                            this.$store.commit('setListaContratos', this.lista_contratos_)
                                            this.request_obter_cliente(this.id_cliente)
                                            this.respondeu_digital()
                                    
                                  }

                                })
                },
                
                handleAlt() { 
                    if (this.$refs.form.validate()) {
                        this.btn_cad_load = true
                                http.get('AcessoCliente/AlterarDadosAcesso/', this.cadastro, {
                                    headers: authHeader()
                                })
                                .then(response => {
                                    this.msg_finish_alterar = response.data.Description
                                    this.finish_alterar_senha = true
                                    this.btn_cad_load = false
                                    this.dialog_cad = false
                                })                                 
                    }
                },


               request_obter_cliente(id) {
                http.get('ClienteDIO/Obter/'+ id, {
                    headers: authHeader()
                }).then(response => {
                        this.cliente = response.data.ResponseData;
                        this.$store.commit('setCliente', this.cliente)
                        this.finish = true
                    })
                    .catch(function (error) {

                    });
            },

            concorrendo(){
                    http.get('concorrendo/' + this.carne_aceito.contrato, {
                    headers: authHeader()
                }).then(response => {

                    if(this.isEmptyObject(response)== false){
                        if(response.data.usou == false){

                            this.theWheel = new Winwheel( this.carne_aceito.contrato, {
                                'numSegments'  : 12,     // Specify number of segments.
                                'outerRadius'  : 262,   // Set outer radius so wheel fits inside the background.
                                'textFontSize' : 20,    // Set font size as desired.
                                'segments'     :        // Define segments including colour and text.
                                [
                                {'fillStyle' : '#a2cc00', 'text' : 'Ganhou Brinde1'},
                                {'fillStyle' : '#41a300', 'text' : 'Não Ganhou2'},
                                {'fillStyle' : '#329a84', 'text' : 'Não Ganhou3'},
                                {'fillStyle' : '#39a3cd', 'text' : 'Ganhou Brinde4'},
                                {'fillStyle' : '#3536c0', 'text' : 'Não Ganhou5'},
                                {'fillStyle' : '#572a9a', 'text' : 'Não Ganhou6'},
                                {'fillStyle' : '#8307a3', 'text' : 'Ganhou Brinde7'},
                                {'fillStyle' : '#f405c4', 'text' : 'Não Ganhou8'},
                                {'fillStyle' : '#f30062	', 'text' : 'Não Ganhou9'},
                                {'fillStyle' : '#cc0000', 'text' : 'Ganhou Brinde10'},
                                {'fillStyle' : '#f46200', 'text' : 'Não Ganhou11'},
                                {'fillStyle' : '#f5c400	', 'text' : 'Não Ganhou12'},

                                ],
                                'animation' :           // Specify the animation to use.
                                {
                                    'type'     : 'spinToStop',
                                    'duration' : 15,     // Duration in seconds.
                                    'spins'    : 30,     // Number of complete spins.
                                    'callbackFinished' :  '' //alertPrize()//"alert('indicatedSegment.text')"
                                }
                            });
                            
                            // Vars used by the code in this page to do power controls.
                            this.wheelPower    = 0
                            this.wheelSpinning = false
                            this.dlg_roleta = true;
                        }

                    }
                    })
                    .catch(function (error) {
                    });

                    
            },
            
            respondeu_digital() {

            //sessionStorage.removeItem('responder_digital')
            const resp = JSON.parse(sessionStorage.getItem('responder_digital'))

            if(resp == null || resp === ""){
                 httpOpen.get('respondeu_carne/'+  this.carne_aceito.contrato, {
                    headers: authHeader()
                }).then(response => {
                        if((response.data == undefined ) || (response.data  === "" )){
                            this.dlg_carne_digital = true
                        }else{
                            this.dlg_carne_digital = false

                        }

                    })
                    .catch(function (error) {

                    });

                axios.get("https://diagnostic.opendns.com/myip")
				.then(response_ => {
                        this.carne_aceito.ip = response_.data
                    })
                     .catch(function (error) {

                    });
                
               
                }
            },

              alterar_digital() {

                var lista_contratos_aux = this.$store.getters.lista_contratos;
                this.lista_contratos_ = [];
                            for (var key in lista_contratos_aux) {
                                this.id_cliente = lista_contratos_aux[key].Cliente.Id
                                 if(lista_contratos_aux[key].RegistroAtivo){
                                    this.carne_aceito.contrato = lista_contratos_aux[key].Referencia;
                                    this.carne_aceito.codigo = this.id_cliente;
                                    this.lista_contratos_.push(lista_contratos_aux[key]);
                                 }
                            } 
   
                this.dlg_carne_digital = true
                axios.get("https://diagnostic.opendns.com/myip")
                                .then(response_ => {
                                    this.carne_aceito.ip = response_.data
                                }).catch(function (error) {

                                });
                
            },

            responder(aceito) {
                
                this.btn_resposta_load = true
                this.carne_aceito.resposta = aceito
                sessionStorage.setItem('responder_digital', "SIM")
                
                httpOpen.post('responder_carne/', this.carne_aceito, {
                    headers: authHeader()
                }).then(response => {
                    this.dlg_carne_digital = false
                    this.dlg_retorno_digital = true

                    })
                    .catch(function (error) {
                       this.btn_resposta_load = false
                    }).finally(() => {
                        if(aceito === 'SIM'){
                           
                             if(sessionStorage.getItem('token') != 'null'){
                                         this.pontosCarne();

                                    }
                                 
                        }
                    });
               
                this.btn_resposta_load = false

            },

             nao_decidi() {
                 sessionStorage.setItem('responder_digital', "SIM")
                 this.dlg_carne_digital = false


            },

            isEmptyObject(obj) {
                        var name;

                        for (name in obj) {
                            return false;
                        }
                        return true;
                }
            },

            isEmpty(obj) {
                for(var prop in obj) {
                    if(obj.hasOwnProperty(prop))
                        return false;
                }

                return true;
            },

          
            
    
       
    }

</script>

<style>
  

   
    .v-dialog {
        box-shadow: none;
    }

    .outine-2 {
        border: 2px solid white;
    }

    .card--flex-toolbar {
        margin-top: -124px;
    }

    .learn-more-btn {
        text-transform: initial;
        text-decoration: underline;
    }
</style>